import React, { FunctionComponent } from 'react'
import { Redirect, Route } from 'react-router'
import { RouteComponentProps } from 'react-router-dom'

import { BasketStatus, useBasket } from '../../context/basket'
interface IPrivateCheckoutRouteProps {
  component: FunctionComponent<RouteComponentProps>
  exact: boolean
  path: string
  redirectPath: string
}

export const PrivateCheckoutRoute: FunctionComponent<
  IPrivateCheckoutRouteProps
> = ({ component, path, redirectPath, exact }) => {
  const [{ viewBasket }] = useBasket()
  return (
    <>
      {viewBasket?.state !== BasketStatus.Default ? (
        <Route path={path} exact={exact} component={component} />
      ) : (
        <Redirect exact={true} to={redirectPath} />
      )}
    </>
  )
}
